export default function CancelButton({ onClick, text, disabled = false, tabIndex }) {
  return (
    <button 
      onClick={onClick} 
      disabled={disabled}
      tabIndex={tabIndex}
      className={`px-2 rounded border-1 text-theme-headerBg border-theme-headerBg hover:bg-theme-headerBg hover:text-theme-color  rounded-1 text-sm font-medium  py-[2px] `}
    >
      {text}
    </button>
  );
};